import axios from 'axios'

export function filenameFromContentDisposition(headers) {
  const raw = headers && (headers['content-disposition'] || headers['Content-Disposition'])
  if (!raw || typeof raw !== 'string') return ''
  const star = raw.match(/filename\*=UTF-8''([^;\n]+)/i)
  if (star) {
    try {
      return decodeURIComponent(star[1].trim())
    } catch (e) {
      /* ignore */
    }
  }
  const m = raw.match(/filename="([^"]+)"/i) || raw.match(/filename=([^;\s]+)/i)
  return m ? m[1].trim() : ''
}

function mimeTypeFromFilename(name) {
  if (!name || typeof name !== 'string') return ''
  const n = name.toLowerCase()
  const i = n.lastIndexOf('.')
  const ext = i >= 0 ? n.slice(i) : ''
  const map = {
    '.pdf': 'application/pdf',
    '.png': 'image/png',
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.gif': 'image/gif',
    '.webp': 'image/webp',
    '.svg': 'image/svg+xml'
  }
  return map[ext] || ''
}

/**
 * 带 token 的 GET：PDF/图片在新标签页打开，其它类型触发下载。
 */
export async function previewBlobAuthenticated(url, fallbackFilename) {
  const token = localStorage.getItem('token')
  const res = await axios.get(url, {
    responseType: 'blob',
    headers: token ? { Authorization: 'Bearer ' + token } : {}
  })
  let ct = (res.headers['content-type'] || '').split(';')[0].trim().toLowerCase()
  const headerName = filenameFromContentDisposition(res.headers)
  const baseName = headerName || fallbackFilename || 'file'
  if (!ct || ct === 'application/octet-stream') {
    const guess = mimeTypeFromFilename(baseName)
    if (guess) ct = guess
  }
  const rawBlob = res.data
  const buf = rawBlob instanceof Blob ? await rawBlob.arrayBuffer() : rawBlob
  const openable = ct === 'application/pdf' || (ct && ct.startsWith('image/'))
  const finalBlob = new Blob([buf], { type: openable && ct ? ct : 'application/octet-stream' })
  const blobUrl = window.URL.createObjectURL(finalBlob)
  if (openable) {
    window.open(blobUrl, '_blank', 'noopener')
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 120000)
    return
  }
  try {
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = baseName
    a.click()
  } finally {
    window.URL.revokeObjectURL(blobUrl)
  }
}

/**
 * 带当前登录 token 的 GET 下载，触发浏览器保存。
 */
export async function downloadBlobAuthenticated(url, fallbackFilename) {
  const token = localStorage.getItem('token')
  const res = await axios.get(url, {
    responseType: 'blob',
    headers: token ? { Authorization: 'Bearer ' + token } : {}
  })
  const name = filenameFromContentDisposition(res.headers) || fallbackFilename || 'download.bin'
  const blobUrl = window.URL.createObjectURL(new Blob([res.data]))
  try {
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = name
    a.click()
  } finally {
    window.URL.revokeObjectURL(blobUrl)
  }
}
